export const API_V1_URI = "/api/v1";

export const ACCOUNT_API = API_V1_URI + "/accounts";
export const ACCOUNT_API_REFRESH_TOKEN = ACCOUNT_API + "/refresh-token";
export const ACCOUNT_API_PROFILE = ACCOUNT_API + "/profile";

export const CLIENT_API_V1_URI = API_V1_URI + "/client";

export const CLIENT_PRODUCT_CATEGORY_API =
  CLIENT_API_V1_URI + "/product_categories";
export const CLIENT_APPLY_PROMOTION_API =
  CLIENT_API_V1_URI + "/apply_promotions";
export const CLIENT_APPLY_CART_PROMOTION_API =
  CLIENT_APPLY_PROMOTION_API + "/ready_for_cart";
export const CLIENT_APPLY_MULTIPLE_PROMOTION_CART_API =
  CLIENT_APPLY_PROMOTION_API + "/ready_multiple_for_cart";
export const CLIENT_BRANCH_API = CLIENT_API_V1_URI + "/branches";
export const CLIENT_BRANCH_ORDER_SETTING_API =
  CLIENT_API_V1_URI + "/branch_order_pickup_setting";

export const CLIENT_CUSTOMER_ADDRESS_API =
  CLIENT_API_V1_URI + "/customer_addresses";

export const ADDRESS_API = API_V1_URI + "/addresses";
export const ADDRESS_COUNTRIES_API = ADDRESS_API + "/countries";

export const CLIENT_SHOPPING_CART_API = CLIENT_API_V1_URI + "/shopping_cart";
export const CLIENT_SHOPPING_CART_ITEMS_API =
  CLIENT_SHOPPING_CART_API + "/items";
export const CLIENT_SHOPPING_CART_REMOVE_ITEM_API =
  CLIENT_SHOPPING_CART_API + "/remove_item";
export const CLIENT_SHOPPING_CART_RESTORE_API =
  CLIENT_SHOPPING_CART_API + "/restore";
export const CLIENT_SHOPPING_CART_SELECTED_BRANCH_API =
  CLIENT_SHOPPING_CART_API + "/selected_branch";
export const CLIENT_SHOPPING_CART_CLEAR_API =
  CLIENT_SHOPPING_CART_API + "/clear_cart";

export const CLIENT_ORDER_API = CLIENT_API_V1_URI + "/orders";
export const CLIENT_ORDER_APPLY_COUPON_API = CLIENT_ORDER_API + "/apply_coupon";
export const CLIENT_ORDER_AVAILABLE_TIME_API =
  CLIENT_ORDER_API + "/available_pick_up_time";
export const CLIENT_ORDER_PLACE_ORDER_API = CLIENT_ORDER_API + "/place_order";
export const CLIENT_ORDER_PLACE_ORDER_GUEST_API = CLIENT_ORDER_API + "/place_order_guest";
export const CLIENT_ORDER_PAYMENT_API = CLIENT_API_V1_URI + "/order_payments";
export const CLIENT_ORDER_PAYMENT_GUEST_API = CLIENT_ORDER_PAYMENT_API + "/confirm_checkout_guest";

